import request from "@/utils/request";

export function getListPrice({ pageNumb, pageSize, data, signal }) {
  return request({
    url:
      "/mgr/searchPriceList/querySearchPrice?pageSize=" +
      pageSize +
      "&pageNumb=" +
      pageNumb,
    method: "post",
    data,
    signal,
  });
}
